import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiRequest } from '../api';
import { AuthContext } from '../context/AuthContext';
import API_BASE_URL from '../apiConfig';
import './LoginForm.css';

const escapeHTML = (input) => {
    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
};

const LoginForm = ({ referrerId }) => {
    const { t, i18n } = useTranslation('login');
    const { user, fetchUserDetails } = useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);


    useEffect(() => {

  const authUrl = referrerId 
    ? `${API_BASE_URL}/api/auth/telegram?referrerId=${referrerId}` 
    : `${API_BASE_URL}/api/auth/telegram`;

  const script = document.createElement('script');
  script.src = 'https://telegram.org/js/telegram-widget.js?7';
  script.setAttribute('data-telegram-login', 'TG_Game_stars_bot');
  script.setAttribute('data-size', 'large');
  script.setAttribute('data-auth-url', authUrl);
  script.setAttribute('data-request-access', 'write');
  script.setAttribute('data-radius', '10');
  script.setAttribute('data-lang', i18n.language); // Use current i18n language
  script.async = true;

  const container = document.getElementById('telegram-login-container');
  container.appendChild(script);

  script.onload = () => setTimeout(() => setLoading(false), 300);
  return () => container.removeChild(script);
}, [location, i18n.language, referrerId]);

    useEffect(() => {
    const initData = window.Telegram?.WebApp?.initData;

    if (initData && !isLoggedIn) {
        handleAutoLogin(initData, referrerId);
    }
}, [isLoggedIn]);

    const handleAutoLogin = async (initData,referrerId ) => {
        setIsProcessing(true);
        setLoading(true);
        
        
        try {
            const response = await apiRequest(`${API_BASE_URL}/api/auth/telegram`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ initData, referrerId }),
            });
            
            const data = await response.json();
            if (response.ok) {
                const fetchedUser = await fetchUserDetails();
                setIsLoggedIn(true);
                if (fetchedUser && fetchedUser.hasSeenWelcomeScreens) {
                navigate('/game', { replace: true });
                } else {
                navigate('/welcome', { replace: true });
                }
            } else {
                setMessage(t(data.message || 'login_failed'));
            }
        } catch (error) {
            setMessage(t('server_error'));
        } finally {
            setIsProcessing(false);
            setLoading(false);
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsProcessing(true);

        const sanitizedUsername = escapeHTML(username);

        try {
            const response = await apiRequest(`${API_BASE_URL}/api/login`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username: sanitizedUsername, password }),
            });

            const data = await response.json();
            if (response.ok) {
               const fetchedUser = await fetchUserDetails();
                if (fetchedUser && fetchedUser.hasSeenWelcomeScreens) {
                    navigate('/game', { replace: true });
                } else {
                navigate('/welcome', { replace: true });
                }
            } else {
                setMessage(t(data.message || 'login_failed'));
            }
        } catch (error) {
            setMessage(t('server_error'));
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="login-container">
            {loading && <div id="login-loading-screen" className="login-loading-screen">{t('loading')}</div>}
                       
            <h2 className="login-title">{t('title')}</h2>
            <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                    <label>{t('username')}:</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        className="input-field"
                    />
                </div>
                <div className="form-group">
                    <label>{t('password')}:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="input-field"
                    />
                </div>
                <button 
                    type="submit"
                    className={`login-button ${isProcessing ? 'login-disabled' : ''}`}
                    disabled={isProcessing}
                >
                    {isProcessing ? (
                        <>
                            <span className="spinner"></span> {t('logging_in')}
                        </>
                    ) : t('submit')}
                </button>

                <div id="telegram-login-container" className="telegram-login-container"></div>
            </form>
            {message && <p className="error-message">{message}</p>}

            <div className="login-options">
                <button className="link-button" onClick={() => navigate('/forgot-password')}>
                    {t('forgot_password')}
                </button>
                <button className="link-button" onClick={() => navigate('/register')}>
                    {t('register')}
                </button>
            </div>
        </div>
    );
};

export default LoginForm;